import { normalize } from 'normalizr'

import * as auth from '../auth'
import { jsonPost } from '../api'

const toVehiclePayload = (vehicle, selectedVehicleIds) => ({
    Id: vehicle.id,
    Tag: vehicle.tag,
    State: vehicle.state,
    Color: vehicle.color,
    Make: vehicle.make,
    Model: vehicle.model,
    Name: vehicle.name,
    Active: Boolean(vehicle.active ?? true),
    Rental: Boolean(vehicle.rental ?? false),
    RentalExpiryDate: vehicle.rentalExpiryDate ?? null,
    OnDemandOptIn: selectedVehicleIds.includes(vehicle.id),
})

const toCardPayload = (card, selectedCardId) => ({
    Id: card.id,
    CardLast4: card.cardLast4,
    ccToken: card.ccToken,
    ExpDate: card.expDate,
    Name: card.name,
    CardType: card.cardType,
    Active: Boolean(card.active ?? true),
    NickName: card.nickName,
    CardProcessor: card.cardProcessor,
    CardMode: card.cardMode,
    OnDemandOptIn: card.id === selectedCardId,
})

export const updateOnDemandParking = ({
    token,
    details,
    vehicles,
    creditCards,
    enable,
    selectedVehicleIds,
    selectedCardId,
}) =>
    jsonPost(`${GRS_ACCOUNTS_SERVICE}/CreateAccount`, {
        LAZAccountDetail: {
            ParkingIndividualDetail: {
                Id: 0,
                Salutation: details.salutation,
                FirstName: details.firstName,
                LastName: details.lastName,
                Phone: details.phone,
                EmailAddress: details.emailAddress,
                OnDemandOptIn: enable,
                Address1: details.billingAddress.address1,
                Address2: details.billingAddress.address2,
                City: details.billingAddress.city,
                State: details.billingAddress.state,
                PostalCode: details.billingAddress.postalCode,
                Country: details.billingAddress.country,
                Billing_FirstName: details.billingAddress.firstName,
                Billing_LastName: details.billingAddress.lastName,
                Billing_Address1: details.billingAddress.address1,
                Billing_Address2: details.billingAddress.address2,
                Billing_City: details.billingAddress.city,
                Billing_State: details.billingAddress.state,
                Billing_PostalCode: details.billingAddress.postalCode,
                Billing_Country: details.billingAddress.country,
                Billing_District: details.billingAddress.district,
                Billing_Number: details.billingAddress.streetNumber,
                DeliveryName: details.deliveryAddress.firstName,
                DeliveryAddress: details.deliveryAddress.address1,
                DeliveryAddress2: details.deliveryAddress.address2,
                DeliveryCity: details.deliveryAddress.city,
                DeliveryState: details.deliveryAddress.state,
                DeliveryPostCode: details.deliveryAddress.postalCode,
                DeliveryCountry: details.deliveryAddress.country,
                DeliveryDistrict: details.deliveryAddress.district,
                DeliveryNumber: details.deliveryAddress.streetNumber,
                VehicleDetail: vehicles.map(vehicle => toVehiclePayload(vehicle, selectedVehicleIds)),
                Custom1: details.custom1,
                Custom2: details.custom2,
                CustomerDocumentType: details.document?.type,
                CustomerDocumentNumber: details.document?.number,
            },
            AccountCardDetail: creditCards.map(card => toCardPayload(card, selectedCardId)),
            Token: token,
        },
    })
        .then(response => normalize(response, auth.schemas.userSchema))
        .catch(error => {
            throw new Error(error.message)
        })
